import { render, staticRenderFns } from "./QualificationPayments.vue?vue&type=template&id=88684650&scoped=true&"
import script from "./QualificationPayments.vue?vue&type=script&lang=ts&"
export * from "./QualificationPayments.vue?vue&type=script&lang=ts&"
import style0 from "./QualificationPayments.vue?vue&type=style&index=0&id=88684650&lang=scss&scoped=true&"
import style1 from "./QualificationPayments.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88684650",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBreadcrumbs,VBtn,VCard,VDataTable})
